import { render } from "./BookingHelpDetailsBanner.vue?vue&type=template&id=2ab964f7"
import script from "./BookingHelpDetailsBanner.vue?vue&type=script&lang=js"
export * from "./BookingHelpDetailsBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__